// Extension → { icon class (boxicons), color, label }
const EXT_MAP = {
  // Images
  jpg:  { icon: 'bx bx-image-alt',    color: '#10b981', label: 'JPG'  },
  jpeg: { icon: 'bx bx-image-alt',    color: '#10b981', label: 'JPEG' },
  png:  { icon: 'bx bx-image-alt',    color: '#10b981', label: 'PNG'  },
  gif:  { icon: 'bx bx-image-alt',    color: '#10b981', label: 'GIF'  },
  webp: { icon: 'bx bx-image-alt',    color: '#10b981', label: 'WEBP' },
  svg:  { icon: 'bx bxs-vector',      color: '#06b6d4', label: 'SVG'  },
  bmp:  { icon: 'bx bx-image-alt',    color: '#10b981', label: 'BMP'  },
  ico:  { icon: 'bx bx-image-alt',    color: '#10b981', label: 'ICO'  },
  tiff: { icon: 'bx bx-image-alt',    color: '#10b981', label: 'TIFF' },
  psd:  { icon: 'bx bxs-layer',       color: '#2563eb', label: 'PSD'  },
  ai:   { icon: 'bx bxs-pen',         color: '#f59e0b', label: 'AI'   },

  // Documents
  pdf:  { icon: 'bx bxs-file-pdf',    color: '#ef4444', label: 'PDF'  },
  doc:  { icon: 'bx bxs-file-doc',    color: '#2563eb', label: 'DOC'  },
  docx: { icon: 'bx bxs-file-doc',    color: '#2563eb', label: 'DOCX' },
  xls:  { icon: 'bx bxs-spreadsheet', color: '#16a34a', label: 'XLS'  },
  xlsx: { icon: 'bx bxs-spreadsheet', color: '#16a34a', label: 'XLSX' },
  ppt:  { icon: 'bx bx-slideshow',    color: '#ea580c', label: 'PPT'  },
  pptx: { icon: 'bx bx-slideshow',    color: '#ea580c', label: 'PPTX' },
  txt:  { icon: 'bx bx-file-blank',   color: '#6b7280', label: 'TXT'  },
  rtf:  { icon: 'bx bx-file-blank',   color: '#6b7280', label: 'RTF'  },
  md:   { icon: 'bx bxl-markdown',    color: '#1d4ed8', label: 'MD'   },
  csv:  { icon: 'bx bxs-spreadsheet', color: '#15803d', label: 'CSV'  },

  // Code
  html: { icon: 'bx bxl-html5',       color: '#e34c26', label: 'HTML' },
  css:  { icon: 'bx bxl-css3',        color: '#264de4', label: 'CSS'  },
  scss: { icon: 'bx bxl-sass',        color: '#cd6799', label: 'SCSS' },
  sass: { icon: 'bx bxl-sass',        color: '#cd6799', label: 'SASS' },
  js:   { icon: 'bx bxl-javascript',  color: '#f7df1e', label: 'JS'   },
  ts:   { icon: 'bx bxl-typescript',  color: '#3178c6', label: 'TS'   },
  jsx:  { icon: 'bx bxl-react',       color: '#61dafb', label: 'JSX'  },
  tsx:  { icon: 'bx bxl-react',       color: '#61dafb', label: 'TSX'  },
  vue:  { icon: 'bx bxl-vuejs',       color: '#42b883', label: 'VUE'  },
  json: { icon: 'bx bx-code-curly',   color: '#f59e0b', label: 'JSON' },
  xml:  { icon: 'bx bx-code-alt',     color: '#f97316', label: 'XML'  },
  yaml: { icon: 'bx bx-code-alt',     color: '#f97316', label: 'YAML' },
  yml:  { icon: 'bx bx-code-alt',     color: '#f97316', label: 'YML'  },
  py:   { icon: 'bx bxl-python',      color: '#3776ab', label: 'PY'   },
  php:  { icon: 'bx bxl-php',         color: '#777bb4', label: 'PHP'  },
  rb:   { icon: 'bx bxl-ruby',        color: '#cc342d', label: 'RB'   },
  java: { icon: 'bx bxl-java',        color: '#f89820', label: 'JAVA' },
  cpp:  { icon: 'bx bx-code',         color: '#00599c', label: 'CPP'  },
  c:    { icon: 'bx bx-code',         color: '#00599c', label: 'C'    },
  cs:   { icon: 'bx bx-code',         color: '#9b4993', label: 'C#'   },
  go:   { icon: 'bx bxl-go-lang',     color: '#00add8', label: 'GO'   },
  rs:   { icon: 'bx bx-code',         color: '#ce422b', label: 'RS'   },
  swift:{ icon: 'bx bxl-swift',       color: '#f05138', label: 'SWIFT'},
  kt:   { icon: 'bx bx-code',         color: '#7f52ff', label: 'KT'   },
  sh:   { icon: 'bx bx-terminal',     color: '#4b5563', label: 'SH'   },
  bat:  { icon: 'bx bx-terminal',     color: '#4b5563', label: 'BAT'  },

  // Video
  mp4:  { icon: 'bx bxs-video',       color: '#7c3aed', label: 'MP4'  },
  avi:  { icon: 'bx bxs-video',       color: '#7c3aed', label: 'AVI'  },
  mov:  { icon: 'bx bxs-video',       color: '#7c3aed', label: 'MOV'  },
  mkv:  { icon: 'bx bxs-video',       color: '#7c3aed', label: 'MKV'  },
  webm: { icon: 'bx bxs-video',       color: '#7c3aed', label: 'WEBM' },
  flv:  { icon: 'bx bxs-video',       color: '#7c3aed', label: 'FLV'  },

  // Audio
  mp3:  { icon: 'bx bxs-music',       color: '#db2777', label: 'MP3'  },
  wav:  { icon: 'bx bxs-music',       color: '#db2777', label: 'WAV'  },
  ogg:  { icon: 'bx bxs-music',       color: '#db2777', label: 'OGG'  },
  flac: { icon: 'bx bxs-music',       color: '#db2777', label: 'FLAC' },
  aac:  { icon: 'bx bxs-music',       color: '#db2777', label: 'AAC'  },

  // Archives
  zip:  { icon: 'bx bxs-archive',     color: '#92400e', label: 'ZIP'  },
  rar:  { icon: 'bx bxs-archive',     color: '#92400e', label: 'RAR'  },
  tar:  { icon: 'bx bxs-archive',     color: '#92400e', label: 'TAR'  },
  gz:   { icon: 'bx bxs-archive',     color: '#92400e', label: 'GZ'   },
  '7z': { icon: 'bx bxs-archive',     color: '#92400e', label: '7Z'   },

  // Fonts
  ttf:   { icon: 'bx bx-font',        color: '#6366f1', label: 'TTF'  },
  woff:  { icon: 'bx bx-font',        color: '#6366f1', label: 'WOFF' },
  woff2: { icon: 'bx bx-font',        color: '#6366f1', label: 'WOFF2'},
  otf:   { icon: 'bx bx-font',        color: '#6366f1', label: 'OTF'  },

  // Database
  sql:  { icon: 'bx bx-data',         color: '#0891b2', label: 'SQL'  },
  db:   { icon: 'bx bx-data',         color: '#0891b2', label: 'DB'   },
  sqlite:{ icon: 'bx bx-data',        color: '#0891b2', label: 'DB'   },

  // Executables
  exe:  { icon: 'bx bx-terminal',     color: '#374151', label: 'EXE'  },
  msi:  { icon: 'bx bx-package',      color: '#374151', label: 'MSI'  },
  dmg:  { icon: 'bx bx-package',      color: '#374151', label: 'DMG'  },

  // 3D / Design
  glb:  { icon: 'bx bx-cube-alt',     color: '#8b5cf6', label: 'GLB'  },
  gltf: { icon: 'bx bx-cube-alt',     color: '#8b5cf6', label: 'GLTF' },
  obj:  { icon: 'bx bx-cube-alt',     color: '#8b5cf6', label: 'OBJ'  },
  fbx:  { icon: 'bx bx-cube-alt',     color: '#8b5cf6', label: 'FBX'  },
};

const FOLDER = { icon: 'bx bxs-folder', color: '#f59e0b', label: '' };
const DEFAULT = { icon: 'bx bx-file-blank', color: '#9ca3af', label: '' };

export function useFileIcons() {
  function getIconInfo(item) {
    if (item.type === 'folder') return FOLDER;
    if (item.icon) return { icon: item.icon, color: item.iconColor || '#9ca3af', label: '' };
    const ext = (item.extension || item.name?.split('.').pop() || '').toLowerCase();
    return EXT_MAP[ext] || { ...DEFAULT, label: ext.toUpperCase().slice(0, 5) };
  }

  function isImage(item) {
    const ext = (item.extension || item.name?.split('.').pop() || '').toLowerCase();
    return ['jpg','jpeg','png','gif','webp','bmp','svg'].includes(ext);
  }

  return { getIconInfo, isImage };
}
